export default {
  services_number_title: "Número de servicios para elegir",
  additional_information_after_booking_title:
    "Información adicional en el correo electrónico después de la reserva",
  additional_information_after_booking_subtitle:
    "Información adicional que se enviará en los correos electrónicos relacionados con las reservas de servicios (creación, modificación y recordatorios sobre la reserva). Si has editado las notificaciones, asegúrate de que la variable correspondiente esté configurada en el contenido: [ADDITIONAL_INFORMATION_AFTER_BOOKING].",
  additional_information_after_booking_dummy_text:
    "Este es un texto de ejemplo que será reemplazado por información adicional después de la reserva, si dicha información ha sido proporcionada en la configuración del servicio.",
  plugins_storage_100gb_cd_base_pro_name: "Almacenamiento 100 GB",
  plugins_storage_500gb_cd_base_pro_name: "Almacenamiento 500 GB",
  plugins_storage_100gb_cd_base_pro_description:
    "Más espacio para archivos. Obtén 100 GB adicionales para compartir archivos con clientes y recibir adjuntos a través de formularios de reserva. Una solución ideal para optimizar la comunicación y mejorar la atención al cliente.",
  plugins_storage_500gb_cd_base_pro_description:
    "Espacio máximo para tus archivos. Usa 500 GB de almacenamiento para intercambiar archivos con clientes y recibir adjuntos a través de formularios de reserva sin limitaciones. Esencial para empresas en rápido crecimiento que valoran el profesionalismo y la comodidad.",
  bookings_this_month: "Reservas este mes",
  bookings_all_processed: "Todas las reservas",
  simple_store_product_transactions_this_month: "Productos vendidos este mes",
  files_storage_usage: "Almacenamiento usado",
  files_storage_usage_from_available_prefix: "de los disponibles",
  not_available_in_standard_plan: "Función no disponible en el plan Standard",
  ai_tokens_usage: "Tokens AI utilizados",
  ai_tokens_usage_from_available_prefix: "de los disponibles",
  ai_tokens_resets_at: "Se restablece",
  cancel_reason_dropdown_label: "Motivo de cancelación de la suscripción",
  cancel_subscription_category_1_title: "Problemas técnicos",
  cancel_subscription_category_1_reason_1_title:
    "Caídas frecuentes o interrupciones",
  cancel_subscription_category_1_reason_2_title:
    "Rendimiento lento del sistema",
  cancel_subscription_category_1_reason_3_title: "Interfaz difícil de usar",
  cancel_subscription_category_1_reason_4_title:
    "Problemas con las integraciones (por ejemplo, sistema de pagos, calendarios externos)",
  cancel_subscription_category_1_reason_5_title:
    "Preocupaciones de seguridad (por ejemplo, filtraciones de datos)",
  cancel_subscription_category_1_reason_6_title:
    "Problemas con la aplicación móvil del empleado (por ejemplo, bloqueos, errores)",
  cancel_subscription_category_2_title: "Cambios personales o empresariales",
  cancel_subscription_category_2_reason_1_title:
    "Cambio en el modelo de negocio (por ejemplo, menor necesidad de reservas)",
  cancel_subscription_category_2_reason_2_title:
    "Restricciones presupuestarias o dificultades financieras",
  cancel_subscription_category_2_reason_3_title:
    "Demasiada carga de trabajo para gestionar el sistema",
  cancel_subscription_category_2_reason_4_title:
    "Cierre o reducción del negocio",
  cancel_subscription_category_2_reason_5_title:
    "Falta de tiempo para gestionar las reservas",
  cancel_subscription_category_3_title: "Precio y competencia",
  cancel_subscription_category_3_reason_1_title:
    "Existen alternativas más baratas",
  cancel_subscription_category_3_reason_2_title:
    "Aumento de precio o cambio en el modelo de facturación",
  cancel_subscription_category_4_title: "Problemas de experiencia de usuario",
  cancel_subscription_category_4_reason_1_title:
    "Dificultad para navegar en el sistema",
  cancel_subscription_category_4_reason_2_title: "Faltan funciones esenciales",
  cancel_subscription_category_4_reason_3_title:
    "Demasiado complejo para mi equipo o negocio",
  cancel_subscription_category_4_reason_4_title:
    "Atención al cliente lenta o poco útil",
  cancel_subscription_category_4_reason_5_title:
    "Opciones de personalización limitadas",
  cancel_subscription_category_4_reason_6_title:
    "Proceso de configuración o implementación complicado",
  cancel_subscription_category_5_title: "Factores externos y del mercado",
  cancel_subscription_category_5_reason_1_title:
    "Cambio en las tendencias del mercado (por ejemplo, transición a reservas por redes sociales)",
  cancel_subscription_category_5_reason_2_title:
    "Crisis económica o desaceleración",
  cancel_subscription_category_5_reason_3_title:
    "Cambios en la normativa legal",
  cancel_subscription_category_6_title: "Otros",
  cancel_subscription_category_6_reason_1_title: "Motivo no listado aquí",
  cancel_subscription_category_6_reason_2_title: "Prefiero no decirlo",
  cancel_plan_and_delete_data: "Cancelar y eliminar mis datos",
  cancel_plan_do_nothing: "No hacer nada",
  cancel_plan_and_keep_data_confirmation_label:
    "¿Estás seguro de que quieres cancelar tu suscripción pero conservar tus datos?",
  cancel_plan_and_keep_data_confirmation_info:
    "La suscripción se cancelará al final del período de facturación ya pagado. Los datos se almacenarán de forma segura en nuestros servidores y podrán restaurarse en cualquier momento al reactivar la suscripción.",
  scheduled_cancel_keeps_data_info:
    "Tu plan será cancelado, pero tus datos permanecerán almacenados",
  no_just_checking_title: "No, solo estoy comprobando",
  payment_deadline_before_start_variable:
    "Plazo de pago antes del inicio de cada reserva recurrente",
  send_payment_reminder_before_start_variable:
    "Tiempo de notificación de recordatorio de pago antes de la reserva",
  booking_awaiting_payment_full_description:
    "Información completa sobre el pago requerido",
  booking_awaiting_payment_full_description_example:
    "La reserva será cancelada si no se realiza el pago en 30 min. Haz clic a continuación para ir a tu reserva y realizar el pago.",
  recurring_meeting_in_the_past_warning:
    'No es posible crear una reunión recurrente con fechas de inicio en el pasado. Elige una fecha de inicio en el futuro o desmarca la opción "Este evento se repite".',
  // Booking overlaps dialog
  booking_overlaps_dialog_title: "Conflicto de calendario detectado",
  booking_overlaps_dialog_message:
    "Al verificar la disponibilidad, detectamos que el horario seleccionado está en conflicto con reservas existentes o fechas bloqueadas. Detalles del conflicto:",
  booking_overlaps_count: "Número de reservas en conflicto",
  unavailable_slot_overlaps_count: "Número de fechas bloqueadas en conflicto",
  booking_overlaps_dialog_question: "¿Quieres continuar de todos modos?",
  selected_date: "Fecha seleccionada",
  single_booking: "Reserva individual",
  external_api_service_not_enabled_error:
    "Lamentablemente, la función de la API no está disponible en esta cuenta.",
  service_not_available_at_selected_time:
    "El servicio no está disponible en el horario seleccionado.",
  offline_mode: "Estás desconectado",
  offline_description:
    "La aplicación requiere una conexión a internet para funcionar.",
  retry: "Reintentar",
  checking_connection: "Verificando conexión...",
  waiting_for_connection: "Esperando conexión",
  "2fa_verify_title": "Autenticación de dos factores",
  "2fa_verify_description":
    "Ingresa tu código de 6 dígitos de tu aplicación autenticadora o usa un código de recuperación:",
  "2fa_recovery_code_label": "Código de recuperación",
  "2fa_use_recovery_code": "Usar código de recuperación",
  "2fa_use_app_code": "Usar código de app",
  "2fa_verify_incorrect_error":
    "El código 2FA es incorrecto. Por favor, intenta de nuevo.",
  "2fa_session_expired_error":
    "Tu sesión 2FA ha expirado. Inicia sesión de nuevo.",
  "2fa_verification_cancelled":
    "La autenticación de dos factores fue cancelada. Inténtalo de nuevo.",
  enable_2fa: "Activar 2FA",
  enable_2fa_title: "Activar verificación en 2 pasos",
  disable_2fa: "Desactivar 2FA",
  disable_2fa_title: "Desactivar verificación en 2 pasos",
  "2fa_manual_setup": "¿No puedes escanear? Ingresa este código manualmente:",
  "2fa_recovery_codes_title": "Códigos de recuperación",
  "2fa_download_codes": "Descargar códigos",
  "2fa_disable_description":
    "Estás a punto de desactivar la verificación en 2 pasos. Esto hará tu cuenta menos segura.",
  "2fa_disable_warning":
    "Desactivar la verificación en 2 pasos reducirá la seguridad de tu cuenta.",
  "2fa_verify_to_disable": "Verificar tu identidad",
  "2fa_verify_to_disable_description":
    "Ingresa un código de tu app autenticadora o usa un código de recuperación para desactivar la verificación en 2 pasos.",
  warning: "Advertencia",
  current_password: "Contraseña actual",
  incorrect_password: "Contraseña incorrecta. Por favor, inténtalo de nuevo.",
  "2fa_setup_failed": "Error al configurar 2FA",
  "2fa_activation_failed": "Error al activar 2FA",
  "2fa_verification_code": "Código de verificación",
  "2fa_disabled_success": "2FA se ha desactivado correctamente",
  "2fa_disable_failed": "Error al desactivar 2FA",
  "2fa_step_1_password_title": "Ingresa tu contraseña",
  "2fa_step_1_scan_title": "Escanear código QR",
  "2fa_step_2_verify_title": "Verificar configuración",
  "2fa_authenticator_apps_required": "Se requiere app autenticadora",
  "2fa_setup_secure_subtitle":
    "Elige e instala una app 2FA segura para proteger tu cuenta",
  "2fa_apps_installation_note":
    "Instala una de estas apps en tu teléfono antes de continuar con la configuración.",
  "2fa_scan_with_app": "Escanea este código QR con tu app autenticadora",
  "2fa_enter_code_from_app":
    "Introduce el código de 6 dígitos de tu app autenticadora",
  "2fa_recovery_codes_warning":
    "Guarda estos códigos en un lugar seguro. Cada código solo puede usarse una vez.",
  "2fa_enter_password_to_continue":
    "Introduce tu contraseña actual para generar tu código QR único",
  "2fa_enter_password_to_disable":
    "Introduce tu contraseña actual para confirmar la desactivación de 2FA",
  "2fa_disable_verification_description":
    "Introduce tu contraseña actual y un código de tu aplicación autenticadora o usa un código de recuperación para desactivar la verificación en 2 pasos.",
  "2fa_recovery_codes_description":
    "Estos códigos de respaldo te permiten acceder a tu cuenta si pierdes tu aplicación autenticadora. Cada código solo puede usarse una vez, guárdalos en un lugar seguro.",
  security_settings: "Configuración de seguridad",
  security_settings_description:
    "Gestiona la configuración de seguridad de tu cuenta y los métodos de autenticación.",
  "2fa_security_title": "Verificación en 2 pasos",
  "2fa_security_description":
    "Añade una capa extra de seguridad a tu cuenta con la verificación en 2 pasos.",
  reset_password_description:
    "Envía un enlace de restablecimiento de contraseña a tu dirección de correo electrónico.",
  "2fa_enabled_success": "2FA se ha activado correctamente",
  linkedin: "LinkedIn",
  profile_company_social_media_linkedin_label_input:
    "Enlace a un perfil de LinkedIn",
  logs_diff_linkedin: "Enlace a un perfil de LinkedIn",
  tiktok: "TikTok",
  profile_company_social_media_tiktok_label_input:
    "Enlace a un perfil de TikTok",
  logs_diff_tiktok: "Enlace a un perfil de TikTok",
  wb_linkedin: "URL de LinkedIn",
  wb_tiktok: "URL de TikTok",
  // Chatwoot package
  plugins_calendesk_chat_cd_base_standard_name: "Calendesk Chat",
  plugins_calendesk_chat_cd_base_standard_description:
    "Mejora la comunicación con tus clientes con Calendesk Chat. Proporciona soporte en tiempo real, responde preguntas e interactúa con tus clientes directamente desde tu página de reservas. Perfecto para empresas que desean construir relaciones más fuertes con sus clientes.",
  plugins_calendesk_chat_cd_base_pro_name: "Calendesk Chat",
  plugins_calendesk_chat_cd_base_pro_description:
    "Mejora la comunicación con tus clientes con Calendesk Chat. Proporciona soporte en tiempo real, responde preguntas e interactúa con tus clientes directamente desde tu página de reservas. Perfecto para empresas que desean construir relaciones más fuertes con sus clientes.",
  number_of_agents: "Número de agentes",
  agents_plural: "agentes",
  // Chatwoot integration
  integrations_category_customer_support: "Atención al cliente",
  chatwoot_title: "Calendesk Chat",
  chatwoot_description:
    "Gestiona tu soporte de chat en vivo. Accede al panel, configura agentes y visualiza conversaciones.",
  chatwoot_package_not_active:
    "El paquete Calendesk Chat no está activo. Por favor, actívalo en la configuración de tu suscripción.",
  chatwoot_setup_title: "Configura tu soporte de chat",
  chatwoot_setup_info:
    'Calendesk Chat es una aplicación separada disponible en <a href="https://chat.calendesk.com" target="_blank">chat.calendesk.com</a> donde gestionarás las conversaciones con los clientes.',
  chatwoot_setup_sso_warning:
    "Todos los administradores de Calendesk con acceso a integraciones podrán iniciar sesión en el panel de chat.",
  chatwoot_setup_next_steps_title: "Después de la configuración:",
  chatwoot_setup_next_step_1:
    'Se creará una cuenta de chat en <a href="https://chat.calendesk.com" target="_blank">chat.calendesk.com</a>',
  chatwoot_setup_next_step_2:
    "Los administradores podrán iniciar sesión en el panel de chat con un clic desde el menú de Calendesk",
  chatwoot_setup_next_step_3:
    "Podrás añadir el widget de chat a tu página de reservas - el código para insertar está disponible en el panel de chat",
  chatwoot_company_section_title: "Datos de la empresa",
  chatwoot_admin_section_title: "Administrador del chat",
  chatwoot_business_name: "Nombre de la empresa",
  chatwoot_business_name_hint:
    "Visible para los clientes en el widget de chat y las notificaciones",
  chatwoot_admin_name: "Nombre",
  chatwoot_admin_email: "Correo electrónico",
  chatwoot_support_email: "Correo de atención al cliente",
  chatwoot_support_email_placeholder: "ej. soporte@tuempresa.com",
  chatwoot_support_email_hint:
    "Los clientes verán esta dirección como remitente de las respuestas por correo de tu equipo",
  chatwoot_start_integration: "Configurar",
  chatwoot_integration_active: "Calendesk Chat está activo y listo para usar.",
  chatwoot_dashboard_info:
    'Gestiona tus conversaciones, agentes y ajustes en el panel de chat en <a href="https://chat.calendesk.com" target="_blank">chat.calendesk.com</a>.',
  chatwoot_sso_warning:
    "Todos los administradores de Calendesk con acceso a integraciones pueden iniciar sesión en el panel de chat con un clic.",
  chatwoot_open_dashboard: "Abrir panel",
  chatwoot_agent_limit: "Plazas de agente",
  chatwoot_buy_more_agents: "¿Necesitas más agentes? Mejora tu paquete",
  chatwoot_integration_success:
    "¡Calendesk Chat se ha configurado correctamente!",
  chatwoot_integration_error:
    "No se pudo configurar Calendesk Chat. Por favor, inténtalo de nuevo o contacta con soporte.",
  chatwoot_sso_error:
    "No se pudo abrir el panel de chat. Por favor, inténtalo de nuevo o contacta con soporte.",
  chatwoot_suspend_button: "Suspender",
  chatwoot_suspend_title: "Suspender Calendesk Chat",
  chatwoot_suspend_warning:
    "La suspensión desactivará el widget de chat en el sitio web para los clientes finales, <strong>pero no afecta a la actividad del paquete ni a los cargos relacionados</strong>.<br><br>Para cancelar el paquete, ve a <strong>Facturación → Suscripción</strong> y selecciona <strong>Apagar</strong>.",
  chatwoot_suspend_confirm: "Suspender",
  chatwoot_suspend_success: "Calendesk Chat ha sido suspendido.",
  chatwoot_suspend_error:
    "No se pudo suspender Calendesk Chat. Por favor, inténtalo de nuevo o contacta con soporte.",
  chatwoot_suspended_info:
    "Tu cuenta de Calendesk Chat está actualmente suspendida.",
  chatwoot_suspended_data_preserved:
    "Todas tus conversaciones y ajustes se conservan y se restaurarán cuando reactives.",
  chatwoot_reactivate_button: "Reactivar",
  chatwoot_reactivation_success: "¡Calendesk Chat ha sido reactivado!",
  chatwoot_reactivation_error:
    "No se pudo reactivar Calendesk Chat. Por favor, inténtalo de nuevo o contacta con soporte.",
  chatwoot_suspended_tooltip: "Suspendido - haz clic para reactivar",
  chatwoot_agent_limit_exceeded:
    "Tienes @{current} agentes, pero tu paquete solo permite @{limit}.",
  chatwoot_agent_limit_contact_support:
    "Para reactivar Calendesk Chat, contacta con nuestro equipo de soporte. Te ayudaremos a ajustar el número de agentes al límite de tu paquete.",
  contact_support: "Contactar soporte",
  chatwoot_min_agents_info:
    "Mínimo de @{count} agentes requeridos según tu configuración actual de Calendesk Chat.",
  chatwoot_close_confirm_title: "¿Cerrar formulario?",
  chatwoot_close_confirm_warning:
    "Los datos introducidos no se han guardado y se perderán.",
  chatwoot_close_confirm_yes: "Cerrar",
  chatwoot_close_confirm_no: "Volver al formulario",

  dialog_close_confirm_title: "¿Cerrar?",
  dialog_close_confirm_warning: "Los cambios no guardados se perderán.",
  dialog_close_confirm_yes: "Cerrar",
  dialog_close_confirm_no: "Cancelar",

  // Reports
  reports: "Informes",
  reports_granularity: "Agrupar por",
  reports_revenue: "Ingresos y pagos",
  reports_bookings: "Reservas",
  reports_team: "Mi equipo",
  reports_customers: "Clientes y comercio",
  reports_clients: "Clientes",
  reports_subscriptions: "Suscripciones",
  reports_products: "Productos",
  reports_tab_revenue: "Ingresos",
  date_range: "Rango de fechas",
  vs_previous_period: "vs periodo anterior",
  reports_revenue_timeline: "Ingresos en el tiempo",
  reports_top_services: "Mejores servicios",
  reports_top_products: "Mejores productos",
  reports_payment_providers: "Métodos de pago",
  reports_payment_methods_count: "Transacciones por método de pago",
  reports_payment_methods_value: "Ingresos por método de pago",
  reports_payment_timeline: "Pagos en el tiempo",
  reports_bookings_timeline: "Reservas en el tiempo",
  reports_by_service: "Por servicio",
  reports_by_employee: "Por empleado",
  reports_by_delivery_type: "Por tipo de entrega",
  reports_cancellation_reasons: "Razones de cancelación",
  reports_by_day: "Por día de la semana",
  reports_by_hour: "Por hora",
  reports_heatmap: "Mapa de calor de reservas",
  reports_employee_performance: "Rendimiento del equipo",
  reports_service_ranking: "Ranking de servicios",
  reports_by_category: "Por categoría",
  reports_locations: "Ubicaciones",
  reports_customer_segments: "Compromiso de clientes",
  reports_top_customers: "Mejores clientes",
  reports_product_revenue_timeline: "Ingresos de productos en el tiempo",
  reports_top_subscriptions: "Mejores suscripciones",
  reports_subscription_timeline: "Nuevas suscripciones en el tiempo",
  reports_revenue_forecast: "Pronóstico de ingresos",
  reports_bookings_forecast: "Pronóstico de reservas",

  // Section headers
  reports_section_key_metrics: "Indicadores clave",
  reports_section_key_metrics_tooltip:
    "<b>Indicadores clave</b><br><br>Resumen de tus principales métricas en el período seleccionado. Las flechas muestran cambios respecto al período anterior de la misma duración.",
  reports_section_trends: "Tendencias",
  reports_section_trends_tooltip:
    "<b>Tendencias</b><br><br>Cómo cambiaron tus ingresos y reservas en el período seleccionado.",
  reports_section_revenue: "Ingresos",
  reports_section_revenue_tooltip:
    "<b>Ingresos</b><br><br>Ingresos totales de todas las fuentes en el período seleccionado. Solo se cuentan los <b>pagos completados</b>.<br><br>Incluye:<br>• <b>Desglose de ingresos</b> — de reservas, suscripciones y productos<br>• <b>Valor prom. de reserva</b> y <b>tasa de pago</b><br>• <b>Línea temporal de ingresos</b> — cómo cambiaron los ingresos en el tiempo<br>• <b>Mejores servicios, suscripciones y productos</b> — clasificados por ingresos<br>• <b>Métodos de pago</b> — número de transacciones e ingresos por método",
  reports_section_bookings: "Reservas",
  reports_section_bookings_tooltip:
    "<b>Reservas</b><br><br>Estados de reservas, volumen en el tiempo y desglose por servicio y miembro del equipo en el período seleccionado.<br><br>Incluye:<br>• <b>Desglose por estado</b> — aprobadas, completadas, canceladas<br>• <b>Línea temporal de reservas</b> — cambios de volumen en el tiempo<br>• <b>Por servicio y miembro del equipo</b> — servicios más reservados y personal más ocupado",
  reports_section_patterns: "Patrones de reserva",
  reports_section_patterns_tooltip:
    "<b>Patrones de reserva</b><br><br>Cuándo prefieren reservar tus clientes. Usa esto para optimizar tu horario.<br><br>Incluye:<br>• <b>Mapa de calor</b> — días y horas más concurridos<br>• <b>Día más popular</b> — qué día de la semana tiene más reservas<br>• <b>Por hora</b> — distribución de reservas a lo largo del día",
  reports_section_employees: "Mi equipo",
  reports_section_employees_tooltip:
    "<b>Mi equipo</b><br><br>Cómo rindió cada miembro del equipo en el período seleccionado.<br><br>Incluye:<br>• <b>Reservas completadas</b> — número de reservas terminadas por persona<br>• <b>Ingresos generados</b> — ingresos de sus reservas<br>• <b>Ocupación de agenda</b> — cuánto de su tiempo disponible estuvo reservado",
  reports_section_services: "Servicios",
  reports_section_services_tooltip:
    "<b>Servicios</b><br><br>Servicios más populares y sus ingresos en el período seleccionado.<br><br>Incluye:<br>• <b>Reservas por servicio</b> — número de reservas aprobadas y completadas<br>• <b>Ingresos por servicio</b> — ingresos generados",
  reports_section_locations: "Ubicaciones",
  reports_section_locations_tooltip:
    "<b>Ubicaciones</b><br><br>Desglose de rendimiento por ubicación y tipo de entrega en el período seleccionado.",
  reports_section_customers: "Clientes",
  reports_section_customers_tooltip:
    "<b>Clientes</b><br><br>Quién reserva más seguido, quién gasta más y qué tan comprometidos están tus clientes en el período seleccionado.<br><br>Incluye:<br>• <b>Nuevos clientes</b> — registrados en el período seleccionado<br>• <b>Clientes activos</b> — tuvieron al menos una reserva<br>• <b>Gráfico de compromiso</b> — primerizos, que volvieron y leales habituales<br>• <b>Mejores clientes</b> — con mayor gasto en el período seleccionado",
  reports_section_customer_overview: "Clientes",
  reports_section_customer_overview_tooltip:
    "<b>Clientes</b><br><br>Estos valores cubren toda tu historia y no cambian con el filtro de fechas.",
  reports_section_customer_activity: "Actividad en el período",
  reports_section_customer_activity_tooltip:
    "<b>Actividad en el período</b><br><br>Cómo se involucraron tus clientes en el período seleccionado — reservas, retención y preferencias.",
  reports_section_products: "Productos",
  reports_section_products_tooltip:
    "<b>Productos</b><br><br>Ventas de productos, ingresos en el tiempo y los más vendidos en el período seleccionado.<br><br>Incluye:<br>• <b>Ingresos totales por productos</b> en el período seleccionado<br>• <b>Línea temporal de ingresos</b> — cómo cambiaron las ventas de productos en el tiempo<br>• <b>Mejores productos</b> — los más vendidos por ingresos",
  reports_section_subscriptions: "Suscripciones",
  reports_section_subscriptions_tooltip:
    "<b>Suscripciones</b><br><br>Ingresos, renovaciones y uso de tus planes de suscripción en el período seleccionado.<br><br>Incluye:<br>• <b>Suscripciones activas</b> — cuántos clientes tienen un plan activo ahora mismo<br>• <b>Ingresos</b> — cuánto ganaste con suscripciones en el período seleccionado<br>• <b>Tasa de renovación</b> — cuántos suscriptores han pagado más de una vez (más alto = los clientes vuelven)<br>• <b>Mejores suscripciones</b> — qué planes generan más dinero<br>• <b>Uso</b> — ¿los suscriptores realmente usan sus reservas incluidas?",
  reports_section_booking_status: "Estado de la reserva",
  reports_section_cancellation_reasons: "Motivos de cancelación",
  reports_section_peak_hours: "Horas pico",
  reports_section_peak_hours_tooltip:
    "<b>Cómo leer este gráfico:</b><br><br><b>Filas</b> = días de la semana<br><b>Columnas</b> = horas del día (00:00–23:00)<br><br>Cada celda muestra el <b>número total</b> de reservas aprobadas y completadas programadas en ese día y hora durante <b>todo el período seleccionado</b>.<br><br><b>Ejemplo:</b> Si seleccionaste 3 meses, la celda lunes 10:00 muestra cuántas reservas cayeron en cualquier lunes a las 10:00 durante esos 3 meses combinados.<br><br>🟦 Color más oscuro = más reservas",
  reports_section_busiest_day: "Día más concurrido de la semana",
  stats_monday: "Lunes",
  stats_tuesday: "Martes",
  stats_wednesday: "Miércoles",
  stats_thursday: "Jueves",
  stats_friday: "Viernes",
  stats_saturday: "Sábado",
  stats_sunday: "Domingo",
  stats_mon: "Lun",
  stats_tue: "Mar",
  stats_wed: "Mié",
  stats_thu: "Jue",
  stats_fri: "Vie",
  stats_sat: "Sáb",
  stats_sun: "Dom",
  reports_section_delivery_type: "Por tipo de entrega",
  reports_section_peak_times: "Horarios más populares",
  reports_bookings_by_hour: "Reservas por hora",
  reports_bookings_by_service: "Servicios más reservados",
  reports_bookings_by_employee: "Equipo más activo",
  reports_booking_lead_time: "Antelación de reserva",
  reports_bookings_by_location: "Reservas por ubicación",

  // Renderer-specific notes
  reports_employee_performance_note:
    'El % de ocupación muestra "--" si no se han definido horarios de trabajo para este miembro del equipo.',
  reports_customer_segments_note:
    "Divide a tus clientes activos en tres grupos según su historial de reservas. Los tres suman el total de clientes activos.",
  reports_top_customers_note:
    "El total gastado mostrado cubre toda la historia del cliente, no solo el período seleccionado.",
  reports_bookings_timeline_note:
    "Reservas aprobadas y completadas, según la fecha de la reserva.<br><br><b>Pronóstico</b>: una línea discontinua para los próximos períodos — reservas que ya están programadas (aprobadas o pendientes de pago).",
  reports_services_by_category: "Reservas por categoría",
  reports_services_by_category_note:
    "Número de reservas aprobadas y completadas por categoría de servicio en el período seleccionado.",
  reports_service_ranking_note:
    "Ordenado por número de reservas. Haz clic en cualquier columna para reordenar.",
  reports_top_products_note:
    "Productos clasificados por ingresos en el período seleccionado.",
  reports_top_subscriptions_note:
    "Planes de suscripción clasificados por ingresos en el período seleccionado.",
  reports_product_revenue_timeline_note:
    "Cómo cambiaron los ingresos por productos en el período seleccionado.",
  reports_subscription_timeline_note:
    "Número de nuevas suscripciones iniciadas por período.",
  reports_mrr_trend: "Nuevas suscripciones",
  reports_subscription_usage: "Uso de suscripciones",
  reports_subscription_usage_tooltip:
    "¿Tus suscriptores realmente usan las reservas incluidas en sus planes?<br><br>• <b>Uso del límite</b> — si un plan incluye 10 reservas y un cliente usó 3, eso es 30%. Este es el promedio de todos los suscriptores.<br>• <b>Reservas sin usar</b> — el número total de reservas incluidas que nadie usó. Un número alto significa que los suscriptores están desperdiciando reservas disponibles.",

  // Stats labels — KPI cards, table columns, chart headers
  // Dashboard
  stats_revenue: "Ingresos",
  stats_bookings: "Reservas",
  stats_subscriptions: "Suscripciones",
  stats_products: "Productos",
  stats_new_customers: "Nuevos clientes",
  stats_cancellation_rate: "Tasa de cancelación",
  // Revenue
  stats_avg_booking_value: "Valor prom. de reserva",
  stats_total_revenue: "Ingresos totales",
  stats_from_bookings: "Reservas",
  stats_from_products: "Productos",
  stats_from_subscriptions: "Suscripciones",
  // Team
  stats_active_employees: "Empleados activos",
  stats_team_revenue: "Ingresos del equipo",
  stats_schedule_fill_rate: "Ocupación del calendario",
  stats_total_booked_hours: "Horas reservadas totales",
  // Bookings
  stats_total_bookings: "Total de reservas",
  stats_approved: "Aprobadas",
  stats_done: "Completadas",
  stats_cancelled: "Canceladas",
  stats_payment: "Pendiente de pago",
  stats_status: "Estado",
  // Tables — common
  stats_service: "Servicio",
  stats_employee: "Empleado",
  stats_delivery_type: "Tipo de entrega",
  stats_share: "Participación",
  stats_reason: "Razón",
  stats_cancellations: "Cancelaciones",
  stats_category: "Categoría",
  stats_location: "Ubicación",
  stats_type: "Tipo",
  stats_provider: "Método",
  stats_transactions: "Transacciones",
  stats_value: "Total",
  stats_product: "Producto",
  stats_quantity: "Cantidad",
  stats_subscription: "Suscripción",
  stats_customer: "Cliente",
  stats_email: "Email",
  // Employees
  stats_customers_served: "Clientes atendidos",
  stats_utilization: "Utilización",
  stats_available_hours: "Horas disponibles",
  stats_booked_hours: "Horas reservadas",
  // Services
  stats_unique_customers: "Clientes únicos",
  // Customers
  stats_total_customers: "Total de clientes",
  stats_active_customers: "Clientes activos",
  stats_returning_customers: "Clientes recurrentes",
  stats_retention_rate: "Tasa de retención",
  stats_customer_ltv: "Valor del cliente",
  stats_avg_days_between_visits: "Días prom. entre reservas",
  stats_preferred_delivery: "Entrega preferida",
  stats_preferred_payment: "Pago preferido",
  stats_total_spent: "Gasto total",
  // Products
  stats_total_sold: "Total vendido",
  stats_product_revenue: "Ingresos de productos",
  // Subscriptions
  stats_active_subscriptions: "Suscripciones activas",
  stats_subscription_revenue: "Ingresos de suscripciones",
  stats_renewal_rate: "Tasa de renovación",
  stats_active_users: "Usuarios activos",
  stats_avg_utilization: "Uso del límite de reservas",
  stats_booking_limit_usage: "Uso del límite de reservas",
  stats_unused_booking_slots: "Reservas sin usar",
  stats_unused_bookings: "Reservas sin usar",
  // Payments
  stats_total_transactions: "Total de transacciones",
  stats_total_value: "Valor total",
  stats_booking_payment_rate: "Tasa de pago de reservas",
  stats_method: "Método",
  // Patterns
  stats_day: "Día",
  stats_hour: "Hora",
  stats_busiest_day: "Día más activo",
  stats_busiest_hour: "Hora más activa",
  stats_average_lead_time: "Días de anticipación prom.",
  stats_median_lead_time: "Mediana días de anticipación",
  // Forecast
  stats_month: "Mes",
  stats_projected: "Proyectado",
  stats_low_estimate: "Estimación baja",
  stats_high_estimate: "Estimación alta",
  // Chart field names
  stats_period: "Período",
  stats_count: "Cantidad",
  stats_name: "Nombre",

  // KPI tooltips
  stats_cancellation_rate_tooltip:
    "Con qué frecuencia se cancelan las reservas.<br><br><b>Fórmula:</b> canceladas ÷ (aprobadas + completadas + canceladas)<br><b>Ejemplo:</b> 10 reservas, 2 canceladas = <b>20%</b>",
  stats_customer_ltv_tooltip:
    "Cuánto ha gastado un cliente contigo en total, a lo largo de toda su historia — no solo en el período seleccionado.",
  stats_utilization_tooltip:
    "Qué tan llena está tu agenda.<br><br><b>100%</b> — cada espacio disponible estaba reservado<br><b>50%</b> — la mitad de tu tiempo de trabajo no tuvo reservas",
  stats_booking_payment_rate_tooltip:
    "Porcentaje de reservas pagadas del total de reservas programadas en el período seleccionado.",
  stats_renewal_rate_tooltip:
    "Cuántos suscriptores renovaron su plan después del primer pago — una señal de satisfacción del cliente.",
  stats_unused_booking_slots_tooltip:
    "El número total de reservas que los suscriptores podrían haber hecho (según los límites de su plan) pero no hicieron.<br><br><b>Ejemplo:</b> 3 suscriptores tienen un plan con 10 reservas/mes. Uno usó 7, otro 3, otro 0. Eso da 3 + 7 + 10 = <b>20 reservas sin usar</b>.<br><br>Un número alto podría indicar que tus límites son demasiado generosos o que los suscriptores necesitan un recordatorio para reservar.",
  stats_active_subscriptions_tooltip:
    "Nuevas suscripciones que comenzaron en el período seleccionado. <b>No</b> es el número total de todos los suscriptores activos.",
  stats_avg_utilization_tooltip:
    'Algunos planes de suscripción incluyen una cantidad de reservas (ej. "10 reservas al mes"). Esto muestra qué porcentaje de esas reservas tus suscriptores realmente usaron.<br><br><b>Ejemplo:</b> Un cliente compra un plan con 10 reservas/mes pero solo reserva 3 veces → eso es 30% de uso.<br><br>Un porcentaje bajo significa que los suscriptores no aprovechan todo lo que pagaron. Solo cuenta reservas aprobadas y completadas.',
  // Dashboard KPIs
  stats_new_customers_tooltip:
    "Nuevos clientes que se registraron en el período seleccionado. Basado en la fecha de creación de la cuenta.",
  // Revenue section KPIs
  stats_total_revenue_tooltip:
    "Ingresos totales en el período seleccionado de:<br>• reservas<br>• suscripciones<br>• ventas de productos<br><br>Solo se cuentan los <b>pagos completados</b>, según la fecha de pago.",
  stats_from_bookings_tooltip:
    "Ingresos de pagos de reservas en el período seleccionado. Solo se cuentan los <b>pagos completados</b>.",
  stats_from_products_tooltip:
    "Ingresos de compras de productos en el período seleccionado.",
  stats_from_subscriptions_tooltip:
    "Ingresos de pagos de suscripciones en el período seleccionado.",
  // Booking status KPIs
  stats_total_bookings_tooltip:
    "Total de reservas con estado <b>aprobadas</b> y <b>completadas</b> en el período seleccionado. Las reservas <b>canceladas</b> y <b>pendiente de pago</b> no se cuentan.",
  stats_approved_tooltip:
    "Reservas con estado <b>aprobadas</b> (confirmadas) que aún no han tenido lugar.",
  stats_done_tooltip:
    "Reservas que se completaron exitosamente (<b>completadas</b>) en el período seleccionado.",
  stats_cancelled_tooltip:
    "Reservas <b>canceladas</b> en el período seleccionado — por el cliente o por ti.",
  // Team summary KPIs
  stats_active_employees_tooltip:
    "Miembros del equipo con al menos una reserva aprobada o completada en el período seleccionado.",
  stats_team_revenue_tooltip:
    "Ingresos totales por reservas de todos los miembros del equipo en el período seleccionado. Solo se cuentan los pagos completados.",
  stats_schedule_fill_rate_tooltip:
    'Cuánto del tiempo disponible de tu equipo está ocupado con reservas.<br><br><b>Cómo lo calculamos:</b><br>1. Para cada miembro, revisamos cada día del período seleccionado<br>2. Para cada día, verificamos su horario — las excepciones de fecha (días libres, horarios especiales) tienen prioridad sobre el horario semanal<br>3. Sumamos las horas reservadas (reservas aprobadas y completadas)<br>4. Ocupación = horas reservadas ÷ horas disponibles<br>5. Promediamos entre todos los miembros<br><br><b>Ejemplo:</b> Anna tiene 40h disponibles, 20h reservadas → 50%. Mark tiene 40h disponibles, 30h reservadas → 75%. Promedio = <b>62,5%</b><br><br>Los miembros sin horario configurado se omiten. "--" significa que nadie tiene horario.',
  stats_total_booked_hours_tooltip:
    "Horas totales dedicadas a reservas por todo el equipo en el período seleccionado.",
  // Employee KPIs
  stats_customers_served_tooltip:
    "Número de clientes diferentes con los que este miembro del equipo trabajó en el período seleccionado.",
  stats_available_hours_tooltip:
    'Cuántas horas podría trabajar este miembro del equipo en el período seleccionado, según su horario.<br><br><b>Cómo lo calculamos:</b> revisamos cada día del período. Si un día tiene una excepción (ej. día libre), la usamos. Si no, usamos el horario semanal regular.<br><br><b>Ejemplo:</b> lun–vie 9:00–17:00. Período = lun a dom → 5 días laborables × 8h = <b>40h</b>. Si el miércoles está marcado como libre, son 4 × 8h = <b>32h</b>.<br><br>"--" significa que no tiene horario configurado.',
  stats_booked_hours_tooltip:
    "Horas de trabajo que realmente estuvieron ocupadas con reservas en el período seleccionado.",
  // Customer KPIs
  stats_total_tooltip:
    "Número total de clientes registrados contigo — en todo momento, no solo en el período seleccionado.",
  stats_new_tooltip:
    "Clientes que reservaron por primera vez en el período seleccionado — no tenían reservas antes.",
  stats_active_tooltip:
    "Clientes que tuvieron al menos una reserva con estado <b>aprobadas</b> o <b>completadas</b> en el período seleccionado.",
  stats_returning_tooltip:
    "Clientes que ya habían reservado antes del período seleccionado y volvieron durante él.",
  stats_ltv_tooltip:
    "Importe total promedio gastado por un cliente desde que se registró — a lo largo de toda su historia, no solo en el período seleccionado.",
  stats_preferred_delivery_type_tooltip:
    "El formato de reserva más habitual que eligen tus clientes — por ejemplo, en persona, por teléfono o en línea.",
  stats_preferred_payment_method_tooltip:
    "El método de pago que tus clientes usan con más frecuencia al pagar las reservas.",
  stats_total_customers_tooltip:
    "Número total de clientes registrados — de toda la historia, no solo del período seleccionado.",
  stats_active_customers_tooltip:
    "Clientes que tuvieron al menos una reserva en el período seleccionado.",
  stats_returning_customers_tooltip:
    "Clientes que tenían reservas antes del período seleccionado y volvieron durante él. Con <b>Desde el inicio</b> seleccionado, será 0.",
  stats_retention_rate_tooltip:
    "Qué porcentaje de los clientes activos ya había reservado contigo antes.<br><br><b>Fórmula:</b> que vuelven ÷ activos × 100<br><b>Ejemplo:</b> 10 activos, 6 que vuelven = <b>60%</b>",
  stats_avg_days_between_visits_tooltip:
    "En promedio, cuántos días pasan entre reservas para clientes que vienen más de una vez.",
  // Product KPIs
  stats_total_sold_tooltip:
    "Número de productos vendidos en el período seleccionado.",
  stats_product_revenue_tooltip:
    "Ingresos totales de ventas de productos en el período seleccionado.",
  // Subscription KPIs
  stats_subscription_revenue_tooltip:
    "Ingresos totales de pagos de suscripciones en el período seleccionado.",
  stats_active_users_tooltip:
    "Suscriptores que realizaron al menos una reserva usando su suscripción en el período seleccionado.",
  // Payment KPIs
  stats_total_value_tooltip:
    "Suma de todas las transacciones de pago <b>completadas</b> (reservas, productos y suscripciones) en el período seleccionado.",
  // Pattern KPIs
  stats_busiest_day_tooltip:
    "El día de la semana con más reservas en el período seleccionado.",
  stats_busiest_hour_tooltip:
    "La hora del día con más reservas en el período seleccionado.",
  // Forecast KPIs
  stats_low_estimate_tooltip:
    "El extremo inferior del pronóstico — tus resultados podrían estar alrededor de este nivel si el próximo período es más tranquilo de lo habitual.",
  stats_high_estimate_tooltip:
    "El extremo superior del pronóstico — el escenario optimista para el próximo período.",
  // Widget-specific tooltips (shared with dashboard widgets)
  stats_booking_status_tooltip:
    "Desglose de tus reservas por estado — <b>aprobadas</b>, <b>completadas</b> y <b>canceladas</b> — en el período seleccionado.",
  stats_avg_booking_value_tooltip:
    "El importe medio pagado por reserva en el período seleccionado.<br><br><b>Fórmula:</b> ingresos de reservas ÷ número de reservas pagadas",
  stats_mrr_tooltip:
    "Ingresos totales de pagos de suscripción en el período seleccionado. Muestra la suma de todas las transacciones de suscripción pagadas, no una tarifa mensual normalizada.",
  stats_top_clients_tooltip:
    "Tus clientes con mayor gasto en el período seleccionado, clasificados por ingresos totales.",
  stats_top_service_tooltip:
    "El servicio con más reservas en el período seleccionado.",
  stats_revenue_trend_tooltip:
    "Cómo cambiaron tus ingresos en el período seleccionado. Incluye reservas, suscripciones y ventas de productos.<br><br><b>Pronóstico:</b> línea discontinua para los próximos períodos — ingresos de reservas ya cobrados o pendientes de cobro, más ingresos mensuales estimados de suscripciones activas.",
  stats_bookings_timeline_tooltip:
    "Cómo cambió el número de reservas en el período seleccionado. Incluye reservas con estado <b>aprobadas</b> y <b>completadas</b>.<br><br><b>Pronóstico:</b> línea discontinua para los próximos períodos — reservas ya programadas (<b>aprobadas</b> o <b>pendiente de pago</b>).",
  stats_peak_hours_heatmap_tooltip:
    "Mapa de calor que muestra cuándo se producen más reservas — por día de la semana y hora del día. Celdas más oscuras = más reservas.",
  stats_booking_revenue_tooltip:
    "Ingresos solo de pagos de reservas en el período seleccionado — sin ventas de productos ni suscripciones.",
  stats_total_transactions_tooltip:
    "Número total de transacciones de pago procesadas en el período seleccionado, de todas las fuentes.",
  stats_payment_timeline_tooltip:
    "Cómo cambió el valor total de los pagos en el período seleccionado.",
  stats_revenue_timeline_tooltip:
    "Ingresos desglosados por fuente — reservas, suscripciones y productos. Solo pagos completados, según la fecha de pago. Haz clic en los elementos de la leyenda para mostrar u ocultar líneas.<br><br><b>Pronóstico</b>: las líneas discontinuas muestran ingresos proyectados — de reservas ya cobradas o pendientes de cobro, más ingresos estimados de suscripciones activas.",
  stats_revenue_top_services_table_tooltip:
    "Servicios clasificados por ingresos en el período seleccionado.",
  stats_revenue_top_products_table_tooltip:
    "Productos clasificados por ingresos en el período seleccionado.",
  stats_payment_providers_chart_tooltip:
    "Número de transacciones <b>completadas</b> por método de pago (ej. Stripe, efectivo, tarjeta) en el período seleccionado.",
  stats_payment_methods_count_chart_tooltip:
    "Cuántas transacciones se procesaron a través de cada método de pago en el período seleccionado.",
  stats_payment_methods_value_chart_tooltip:
    "Ingresos totales recaudados a través de cada método de pago en el período seleccionado.",
  stats_booking_status_chart_tooltip:
    "Reservas por estado — <b>aprobadas</b>, <b>completadas</b>, <b>canceladas</b> y <b>pendiente de pago</b> — en el período seleccionado.",
  stats_cancellation_reasons_chart_tooltip:
    "Motivos más comunes por los que los clientes cancelaron sus reservas en el período seleccionado.",
  stats_busiest_day_chart_tooltip:
    "Qué días de la semana tienen más reservas en el período seleccionado.",
  stats_delivery_type_chart_tooltip:
    "Cómo se dividen las reservas entre tipos de servicio — presencial, online, telefónico, etc. — en el período seleccionado.",
  stats_peak_times_tooltip:
    "El día y la hora con más reservas con estado <b>aprobadas</b> y <b>completadas</b> en el período seleccionado.",
  stats_bookings_by_hour_tooltip:
    "Cómo se distribuyen las reservas a lo largo de las horas del día en el período seleccionado.",
  stats_bookings_by_service_tooltip:
    "Qué servicios recibieron más reservas en el período seleccionado.",
  stats_bookings_by_employee_tooltip:
    "Qué miembros del equipo gestionaron más reservas en el período seleccionado.",
  stats_booking_lead_time_tooltip:
    "Con cuánta antelación reservan los clientes — el número de días entre la creación de la reserva y la fecha de la reserva.",
  stats_bookings_by_location_tooltip:
    "Cómo se distribuyen las reservas entre tus ubicaciones en el período seleccionado.",
  stats_average_lead_time_tooltip:
    "El promedio de días entre la creación de una reserva y la fecha de la reserva.",
  stats_median_lead_time_tooltip:
    "La mediana de días entre la creación de una reserva y la fecha de la reserva. Menos afectada por valores extremos que el promedio.",
  stats_customer_segments_chart_tooltip:
    "Qué tan comprometidos están tus clientes activos en el período seleccionado:<br>• <b>Primera vez</b> — primera reserva, sin historial previo<br>• <b>Volvieron</b> — tenían reservas antes, visitaron una vez en este período<br>• <b>Leales</b> — tenían reservas antes y vinieron 2+ veces en este período",
  stats_top_customers_table_tooltip:
    "Tus clientes con mayor gasto en el período seleccionado — tabla completa con opción de exportar.",
  stats_employee_table_tooltip:
    "Resumen del rendimiento de cada miembro del equipo — reservas, horas y utilización en el período seleccionado.",
  stats_service_table_tooltip:
    "Resumen del rendimiento de cada servicio — reservas e ingresos en el período seleccionado.",
  stats_services_by_category_tooltip:
    "Número de reservas aprobadas y completadas por categoría de servicio en el período seleccionado.",
  stats_subscription_timeline_tooltip:
    "Cuántas suscripciones nuevas se compraron por período. Se cuentan las fechas de inicio — las renovaciones no se incluyen.",
  stats_top_subscriptions_table_tooltip:
    "Planes de suscripción clasificados por número de suscriptores activos en el período seleccionado.",
  stats_product_timeline_tooltip:
    "Cómo cambiaron los ingresos por productos en el período seleccionado.",
  stats_top_products_table_tooltip:
    "Productos clasificados por volumen de ventas e ingresos en el período seleccionado.",
  stats_not_assigned: "Sin asignar",
  stats_low: "Baja",
  stats_medium: "Media",
  stats_high: "Alta",
  stats_insufficient: "Datos insuficientes",
  stats_type_name: "Tipo de entrega",
  stats_new_subscriptions: "Nuevas suscripciones",
  stats_new: "Nuevos",
  stats_returning: "Recurrentes",
  stats_first_time: "Primera vez",
  stats_first_time_tooltip:
    "Clientes sin reservas antes del período seleccionado — es su primera visita.",
  stats_came_back: "Volvieron",
  stats_came_back_tooltip:
    "Clientes que tenían reservas antes y reservaron una vez en este período.",
  stats_loyal: "Leales",
  stats_loyal_tooltip:
    "Clientes que tenían reservas antes y reservaron 2+ veces en este período.",
  stats_staff: "Personal",
  stats_payment_timeout: "Tiempo de pago agotado",
  stats_calendar_sync: "Sincronización de calendario",
  stats_in_person: "Dirección",
  stats_phone: "Teléfono",
  stats_other: "Otro",
  stats_stripe: "Stripe",
  stats_cash: "Efectivo",
  stats_card: "Tarjeta",
  stats_transfer: "Transferencia",
  stats_google_meet: "Google Meet",
  stats_zoom: "Zoom",
  stats_microsoft_teams: "Microsoft Teams",
  stats_skype: "Skype",
  stats_whatsapp: "WhatsApp",
  stats_client: "Cliente",
  stats_no_payment: "Tiempo de pago agotado",
  stats_external: "Sincronización de calendario",
  bulk_operation_progress: "Procesando: @{done} de @{total}",
  bulk_operation_counting: "Contando registros...",
  bulk_action_delete_bookings: "Eliminando reservas",
  bulk_action_delete_users: "Eliminando usuarios",
  bulk_action_update_users: "Actualizando usuarios",
  bulk_action_export_users: "Exportando usuarios",
  bulk_action_add_to_group: "Agregando a grupos",
  bulk_action_remove_from_group: "Eliminando de grupos",
  bulk_action_send_notification: "Enviando notificaciones",
  bulk_action_update_bookings: "Actualizando reservas",
  bulk_action_export_events: "Exportando eventos",
  bulk_action_update_employees: "Actualizando empleados",
  bulk_action_delete_employees: "Eliminando empleados",
  bulk_action_export_employees: "Exportando empleados",
  bulk_notification_sending: "Enviando notificaciones...",
  bulk_export_generating: "Generando archivo...",
  bulk_export_sent_to_email: "Archivo enviado a tu correo electrónico",
  bulk_export_sent_to_email_with_errors:
    "Archivo enviado a tu correo electrónico. Procesados: @{processed}, errores: @{failed}.",
  download_csv: "Descargar CSV",
  selection_all_on_page:
    "Los @{amount} registros de esta página están seleccionados.",
  selection_select_all_records:
    "Seleccionar los @{total} registros en todas las páginas",
  selection_all_records_selected:
    "Los @{total} registros en todas las páginas están seleccionados.",

  // Dashboard widgets
  your_overview: "Tu resumen",
  add_widget: "Agregar widget",
  widget_group_revenue: "Ingresos",
  widget_group_bookings: "Reservas",
  widget_group_clients: "Clientes",
  widget_group_team: "Mi equipo",
  widget_group_subscriptions: "Suscripciones",
  widget_group_products: "Productos",
  widget_revenue_kpi: "Ingresos",
  widget_bookings_kpi: "Reservas",
  widget_new_clients_kpi: "Nuevos clientes",
  widget_revenue_trend: "Tendencia de ingresos",
  widget_cancellation_rate: "Tasa de cancelación",
  widget_top_clients: "Mejores clientes",
  widget_peak_hours_heatmap: "Horas pico",
  widget_avg_booking_value: "Valor prom. de reserva",
  widget_payment_method: "Método de pago preferido",
  widget_bookings_timeline: "Reservas en el tiempo",
  widget_booking_status: "Estado de reserva",
  widget_busiest_day: "Día más activo",
  widget_busiest_hour: "Hora más activa",
  widget_avg_lead_time: "Tiempo de anticipación prom.",
  widget_active_clients: "Clientes activos",
  widget_retention_rate: "Tasa de retención",
  widget_employee_utilization: "Utilización de empleados",
  widget_top_service: "Mejor servicio",
  widget_active_subscriptions: "Suscripciones activas",
  widget_mrr: "Ingresos por suscripción",
  widget_product_revenue: "Ingresos de productos",
  widget_booking_revenue: "Ingresos de reservas",
  widget_total_transactions: "Total de transacciones",
  widget_payment_conversion: "Tasa de pago de reservas",
  widget_payment_timeline: "Pagos en el tiempo",
  widget_revenue_timeline: "Ingresos en el tiempo",
  widget_revenue_top_services_table: "Top servicios por ingresos",
  widget_revenue_top_products_table: "Top productos por ingresos",
  widget_payment_providers_chart: "Métodos de pago",
  widget_booking_status_chart: "Desglose por estado de reserva",
  widget_cancellation_reasons_chart: "Motivos de cancelación",
  widget_busiest_day_chart: "Reservas por día de la semana",
  widget_delivery_type_chart: "Desglose por tipo de servicio",
  widget_customer_segments_chart: "Segmentos de clientes",
  widget_top_customers_table: "Top clientes (tabla completa)",
  widget_employee_table: "Rendimiento del equipo",
  widget_service_table: "Rendimiento de servicios",
  widget_subscription_timeline: "Nuevas suscripciones en el tiempo",
  widget_top_subscriptions_table: "Top planes de suscripción",
  widget_product_timeline: "Ingresos por productos en el tiempo",
  widget_top_products_table: "Top productos",
  widget_bookings_by_service_table: "Reservas por servicio",
  widget_bookings_by_employee_table: "Equipo más activo",
  widget_bookings_by_hour_chart: "Reservas por hora",
  widget_locations_table: "Reservas por ubicación",
  widget_total_clients: "Total de clientes",
  widget_customer_ltv: "Valor del cliente (LTV)",
  widget_returning_clients: "Clientes recurrentes",
  widget_avg_days_between_visits: "Días prom. entre visitas",
  widget_first_time_clients: "Clientes nuevos (primera visita)",
  widget_repeat_clients: "Clientes recurrentes",
  widget_loyal_clients: "Clientes fieles",
  widget_services_by_category_chart: "Reservas por categoría",
  widget_renewal_rate: "Tasa de renovación",
  widget_subscription_utilization: "Utilización de suscripción",
  widget_unused_booking_slots: "Plazas de reserva sin usar",
  widget_total_products_sold: "Productos vendidos",
  restore_defaults: "Restaurar predeterminados",
  restore_defaults_warning:
    "Esto restablecerá tu panel a los widgets predeterminados. Se perderá tu diseño actual.",
  drag_to_reorder: "Arrastra para reordenar",
  tooltip_add_widget: "Añade un nuevo widget a tu panel",
  tooltip_edit_layout: "Reorganiza o elimina widgets",
  tooltip_restore_defaults: "Restaura el diseño de widgets por defecto",
  tooltip_save_layout: "Guarda el diseño actual de widgets",
  tooltip_remove_widget: "Eliminar este widget",
  add_more_widgets: "Añadir más widgets",
  all_time: "Desde el inicio",
  remove_from_group: "Eliminar del grupo",
  change_status_to_approved: "Establecer como aprobada",
  change_status_to_payment: "Establecer como pendiente de pago",
  change_status_to_cancelled: "Establecer como cancelada",
  change_status_to_done: "Establecer como completada",
  bulk_operation_already_active:
    "Ya tiene una operación masiva activa. Por favor, espere a que se complete.",
};
